import React from 'react'
import Footer from '../components/footer'
import Header from '../components/Header'
import { Outlet } from 'react-router-dom'
import { GeneralSearchProvider } from './Header/GeneralSearch'
import { StoreAiChatOpenProvider } from './AiChat/StoreAiChatOpenContext'
import { ConversationWidgetProvider } from './ConversationWidget'
import { StoreAiChatBubble } from './AiChat/StoreAiChatBubble'

export default function Layout({ useOutlet = true, children }: { useOutlet?: boolean; children?: React.ReactNode }) {
  return (
    <GeneralSearchProvider>
      <StoreAiChatOpenProvider>
        <ConversationWidgetProvider>
          <Header />
          {useOutlet ? <Outlet /> : children}
          <Footer />
          <StoreAiChatBubble />
        </ConversationWidgetProvider>
      </StoreAiChatOpenProvider>
    </GeneralSearchProvider>
  )
}
